module.exports = __webpack_public_path__ + "static/media/jewelry-box.a14eb825.png";